import React, { useEffect, useContext } from 'react';
import Navbar from '../Layout/Navbar/Navbar';
import Footer from '../Layout/Footer/Footer';
import { FilterContext } from '../../context/FilterContext';
import Producto from '../Products/Producto';
import Select from 'react-select';

// react-select theme to match the Fabrilum design language
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 48,
    borderRadius: 14,
    borderColor: state.isFocused ? '#d9892a' : '#e9e6e1',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(227,162,63,0.18)' : 'none',
    backgroundColor: '#fff',
    paddingLeft: 4,
    '&:hover': { borderColor: '#d4cec5' },
  }),
  placeholder: (base) => ({ ...base, color: '#8c7f6c', fontWeight: 300 }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#faedd3',
    borderRadius: 9999,
  }),
  multiValueLabel: (base) => ({ ...base, color: '#6a3a1d', fontSize: 13 }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#9f561e',
    borderRadius: 9999,
    ':hover': { backgroundColor: '#e3a23f', color: '#15130f' },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#d9892a'
      : state.isFocused
      ? '#fdf8ef'
      : '#fff',
    color: state.isSelected ? '#fff' : '#15130f',
    fontSize: 14,
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 14,
    overflow: 'hidden',
    boxShadow: '0 18px 50px -20px rgba(20,19,15,0.35)',
  }),
};

function FilterSelect({ label, options, value, onChange, name }) {
  return (
    <div className="flex-1">
      <label className="mb-2 block text-xs font-medium uppercase tracking-wider2 text-ink-500">
        {label}
      </label>
      {options && (
        <Select
          isMulti
          name={name}
          options={options}
          styles={selectStyles}
          classNamePrefix="select"
          placeholder="Seleccionar"
          noOptionsMessage={() => 'Sin opciones'}
          value={value}
          onChange={onChange}
        />
      )}
    </div>
  );
}

function Productos() {
  const fi = useContext(FilterContext);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const toOptions = (arr) =>
    arr?.map((a) => ({ label: a.nombre, value: a.id }));

  const selectedOptions = (source, ids) =>
    source
      ?.filter((item) => ids?.includes(item.id))
      .map((item) => ({ label: item.nombre, value: item.id })) || [];

  const productos = fi.state.productosDisplay || [];

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar checkScroll={false} />

      <main className="flex-1 pt-28 md:pt-32">
        {/* Page header */}
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <p className="eyebrow">
            <span className="h-px w-10 bg-brand-500" />
            Catálogo completo
          </p>
          <h1 className="mt-4 font-display text-4xl font-medium text-ink md:text-5xl">
            Nuestros productos
          </h1>
          <p className="mt-3 max-w-xl text-sm font-light text-ink-500">
            Filtrá por aplicación, ambiente y tipo de lámpara para encontrar la
            luminaria perfecta.
          </p>
        </div>

        {/* Filters */}
        <div className="sticky top-[83px] z-30 mt-8 border-y border-ink/5 bg-white/85 backdrop-blur-md">
          <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-5 md:flex-row md:px-10">
            <FilterSelect
              label="Aplicación"
              name="Aplicaciones"
              options={toOptions(fi.state.aplicaciones)}
              value={selectedOptions(
                fi.state.aplicaciones,
                fi.state?.filtros?.aplicaciones,
              )}
              onChange={(e) =>
                fi.dispatch({
                  type: 'set_aplicaciones_filter',
                  payload: { aplicaciones: e.map((ap) => ap.value) },
                })
              }
            />
            <FilterSelect
              label="Ambiente"
              name="Ambientes"
              options={toOptions(fi.state.ambientes)}
              value={selectedOptions(
                fi.state.ambientes,
                fi.state?.filtros?.ambientes,
              )}
              onChange={(e) =>
                fi.dispatch({
                  type: 'set_ambientes_filter',
                  payload: { ambientes: e.map((ap) => ap.value) },
                })
              }
            />
            <FilterSelect
              label="Tipo de lámpara"
              name="Lamparas"
              options={toOptions(fi.state.lamparas)}
              value={selectedOptions(
                fi.state.lamparas,
                fi.state?.filtros?.lamparas,
              )}
              onChange={(e) =>
                fi.dispatch({
                  type: 'set_lamparas_filter',
                  payload: { lamparas: e.map((ap) => ap.value) },
                })
              }
            />
          </div>
        </div>

        {/* Grid */}
        <div className="mx-auto max-w-7xl px-6 py-12 md:px-10 md:py-16">
          <p className="mb-8 text-sm font-light text-ink-500">
            {productos.length}{' '}
            {productos.length === 1 ? 'producto' : 'productos'}
          </p>

          {productos.length > 0 ? (
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6 lg:grid-cols-4">
              {productos.map((pr, i) => (
                <Producto key={pr.codigo} data={pr} index={i} />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center rounded-3xl bg-ink-50 py-24 text-center">
              <p className="font-display text-2xl text-ink">
                No encontramos productos
              </p>
              <p className="mt-2 text-sm font-light text-ink-500">
                Probá ajustando los filtros.
              </p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Productos;
